import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=76b7919f&"
import script from "./SimpleHeader.vue?vue&type=script&lang=js&"
export * from "./SimpleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports